// extracted by mini-css-extract-plugin
export default {"container":"SuspenseFallback-module__container__nmuDaD_","placeholder":"SuspenseFallback-module__placeholder__HeZfcK0"};